/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SpacePermissionConfigProviderEntryEntrypointProps } from './SpacePermissionConfigProviderEntry.entrypoint.types.tsx';

type SpacePermissionConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	SpacePermissionConfigProviderEntryEntrypointProps,
	{} | null
>;

export const spacePermissionConfigProviderEntrypoint: EntryPoint<
	SpacePermissionConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<SpacePermissionConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-space-permissions-provider" */ './SpacePermissionConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
